import { CustomAlert, CustomModal, FormEntry } from "components";
import apiService from "services/api";
import AsyncSelect from "react-select/async";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { Button } from "reactstrap";
import { Controller } from "react-hook-form";
import { useState, useRef } from "react";
import { useNotificationContext } from "contexts";
import _ from "lodash";
import { useReducer } from "react";
import { modalAction, modalInitialState, modalReducer } from "../reducers";
import { ImageUploadv2 } from "components/CustomUpload/ImageUploadv2";

const loadStudentCourses = (studentId) => () => {
  return apiService.getMinStudentCourse(studentId).then((courses) =>
    courses.map((course) => ({
      label: course.courseDetail.name,
      value: course.id,
    })),
  );
};

const FormEntryTitle = ({ label }) => (
  <div className="font-weight-bold display-5 text-white ml-2 mb-1">{label}</div>
);

export const AddNewParentMeetingModal = ({
  show,
  hideModal,
  studentId,
  refetch,
}) => {
  const { createNotification } = useNotificationContext();

  const {
    register,
    handleSubmit,
    formState: { errors, isDirty },
    setValue,
    control,
    watch,
    reset,
    getValues,
  } = useForm({ reValidateMode: "onChange" });
  const fileInputRef = useRef(null);

  const extendedHideModal = () => {
    reset();
    hideModal();
  };

  const [confirmationAlertProps, confirmationAlertDispatch] = useReducer(
    modalReducer,
    modalInitialState,
  );

  const triggerConfirmation = () => {
    confirmationAlertDispatch({ type: modalAction.OPEN });
  };

  const closeConfirmationAlert = () => {
    confirmationAlertDispatch({ type: modalAction.CLOSE });
  };

  const confirmSubmit = () => {
    addCourseRecord.mutate(getValues());
  };

  const addCourseRecord = useMutation((data) => {
    apiService.studentPmr
      .create(studentId, data)
      .then(() => {
        closeConfirmationAlert();
        createNotification({
          type: "success",
          message: "Successfully added parent meeting record",
        });
        refetch();
        extendedHideModal();
      })
      .catch((e) => {
        console.error(e);
        createNotification({
          type: "danger",
          message: "Failed to add new parent meeting record",
        });
      });
  });

  return (
    <>
      <CustomAlert
        show={confirmationAlertProps.show}
        hideModal={closeConfirmationAlert}
        title="Confirm Add Payment Record?"
        submitButtonText="Proceed"
        disabled={addCourseRecord.isLoading}
        submitModal={confirmSubmit}
        width="500px"
        body={<div>Are you sure you want to add this course record?</div>}
        fitToParent={false}
      />
      <CustomModal
        show={show}
        hideModal={extendedHideModal}
        title="Add Payment Record"
        triggerAlertWhenClose={isDirty}
        triggerAlertMessageWhenClose="Are you sure you want to leave? All data entered will be lost."
      >
        <form onSubmit={handleSubmit(triggerConfirmation)} className="pb-3">
          <div className="mb-2 row">
            <div className="col-sm-6">
              <FormEntryTitle label="Course" />
              <Controller
                control={control}
                rules={{
                  required: {
                    value: true,
                    message: "Please select a course",
                  },
                }}
                name="studentCourseId"
                render={({ field: { onChange } }) => (
                  <AsyncSelect
                    className="react-select info mb-3"
                    classNamePrefix="react-select"
                    placeholder="Select student course..."
                    cacheOptions
                    loadOptions={loadStudentCourses(studentId)}
                    onChange={(val) => onChange(val.value)}
                    defaultOptions
                  />
                )}
              />
              {errors.courseId && (
                <div className="text-center">
                  <small className="text-danger">
                    {errors.courseId?.message}
                  </small>
                </div>
              )}
            </div>
          </div>
          <div className="mb-3 row">
            <div className="col-12">
              <FormEntry
                register={register}
                name="date"
                errors={errors.date}
                formLabel="Date"
                type="date"
                placeholder="Date"
              />
            </div>
            <div className="col-12">
              <FormEntry
                register={register}
                name="remarks"
                errors={errors.remarks}
                formLabel="Remarks"
                type="paragraph"
                placeholder="Any additional comments..."
                required={false}
              />
            </div>
          </div>

          <div className="mb-3 row">
            <div className="col-12">
              <ImageUploadv2
                fileInputRef={fileInputRef}
                setValue={setValue}
                name="notesData"
                watch={watch}
                labelText="Click here to upload Notes"
              />
            </div>
          </div>

          <div className="d-flex justify-content-end">
            <Button
              color="success"
              type="submit"
              disabled={addCourseRecord.isLoading}
            >
              Submit
            </Button>
          </div>
        </form>
      </CustomModal>
    </>
  );
};
